import {createContext} from 'react';

import {AlertColor} from '@mui/material/Alert/Alert';

export interface SnackBarMessage {
  text: string;
  severity: AlertColor;
}
interface SnackBarContext {
  dispatchMessage: (message: string, severity: AlertColor) => void;
  clearMessage: () => void;
  message?: SnackBarMessage;
}
export const SnackBarContext = createContext<SnackBarContext>({} as SnackBarContext);
